'use client';

import dynamic from 'next/dynamic';
import type { JSX } from 'react';
import { useEffect, useState } from 'react';

const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

interface ILazyLottieProps {
  src: string;
  className?: string;
  loop?: boolean;
}

export function LazyLottie({ src, className, loop = true }: ILazyLottieProps): JSX.Element {
  const [data, setData] = useState<object | null>(null);

  useEffect(() => {
    fetch(src)
      .then((r) => r.json() as Promise<object>)
      .then(setData)
      .catch(() => {});
  }, [src]);

  if (!data) {
    return <div className={className} />;
  }

  return <Lottie animationData={data} loop={loop} className={className} />;
}
